module.exports = __webpack_public_path__ + "static/media/1.f53d7f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/1.mp4
// module id = 5/Vj
// module chunks = 1